<template>
    <div class="box">
        <inner-table
id="archiveFamilyMembers" ref="archiveFamilyMembers"
            :listviewurl="'rsgl.archiveFamilyMembers.list'" :can-edit="canEdit" :can-delete="canEdit"
            :link-prop-name="'archivesId'"
/>

        <!-- <Basicform
        ref="basicform"
          :title="formTitle"
          :module-code="moduleInfo.moduleCode"
          :win-width="moduleInfo.winWidth"
          :win-height="moduleInfo.winHeight"
          :toolbar-btns="busiformBtns"
          :on-basic-form-before-open="onBasicFormBeforeOpen"
          :on-basic-form-opened="onBasicFormOpened"
          :on-basic-form-before-submit="onBasicFormBeforeSubmit"
          :on-basic-form-submited="onBasicFormSubmited"
        >
          <template v-slot:default="slotProps">
            <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
          </template>
        </Basicform> -->

    </div>
</template>

<script>
const moment = require('moment')
export default {
    components: {},
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
            moduleInfo: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/xsgl/archiveFamilyMembers/form.html',
                'addNewUrl': 'xsgl/rsglArchiveFamilyMembers/addNew',
                'insertUrl': 'xsgl/rsglArchiveFamilyMembers/insert',
                'getByIdUrl': 'xsgl/rsglArchiveFamilyMembers/getById',
                'updateUrl': 'xsgl/rsglArchiveFamilyMembers/update',
                'delUrl': 'xsgl/rsglArchiveFamilyMembers/delete',
                'listDataUrl': 'xsgl/rsglArchiveFamilyMembers/listdata',
                'winWidth': 1000,
                'winHeight': 600,
                'moduleCode': 'archiveFamilyMembers',
                'openViewType': '0',
                'listAdvSearchAllFields': 0,
                'listAdvSearchExpandPanel': 0
            },
            formTitle: '家庭成员'
        }
    },
    computed: {},
    watch: {},
    created: function() {
        let formurl = this.moduleInfo.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
        this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    mounted: function() {},
    methods: {
        addObject() {
            this.$bus.emit('openBusiform', this.moduleInfo, null, 1)
        },
        // 内嵌子表-子表单提交前回调
        onInnerBasicFormBeforeSubmit($scope, vo, defer) {
            //vo.archivesId = vo.userId
            defer.resolve(true)
        },
        // 内嵌子表-加载数据后回调
        onInnerTableListDataLoaded($scope, pageInfo) {
            pageInfo.list.forEach(v => {
                v.memberBirthday = v.memberBirthday ? moment(v.memberBirthday).format('YYYY-MM-DD') : ''
            })
        }
    }
}
</script>

<style scoped>
    .header {
        padding: 10px 20px;
        background-color: #f2f5fb;
        font-size: 14px;
        font-weight: 500;
    }

    .box {
        border: 1px solid #dee2e6;
    }
</style>
